import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

interface CheckboxListSearchrops {

}

@Dce("CheckboxListSearch")
export default class DataBagTable extends DceComponent<CheckboxListSearchrops> {

    private timeoutPointer: any = null;
    private labels: JQuery<HTMLElement>;

    constructor(elem: DceHTMLElement, props: CheckboxListSearchrops) {
        super(elem, props);

        let $e = $(this.elem);
        let $input = $e.find('input[type=search]');
        this.labels = $e.find('.checkbox-group label');

        $input.on('input', (e) => {

            let value = $input.val() as string;
            console.log('input event', value);

            if(null != this.timeoutPointer){
                clearTimeout(this.timeoutPointer);
            }
            this.timeoutPointer = setTimeout(() => {
                this.action(value);
            })

        });

    }

    public action(val: string){

        let lowerValue = val.toLowerCase();

        if(lowerValue.trim() == ''){
            this.labels.show();
        }


        this.labels.each((i, e) => {

            console.log(e.textContent);

            if(e.textContent.toLowerCase().trim().startsWith(lowerValue)){
                $(e).show();
            }else{
                $(e).hide();
            }

        })


    }

}
